import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Skeleton } from '../common/skeleton/Skeleton';
import './styles.scss';
const ConfigSocialMediaSkeleton = () => {
  return (
    <Row className="socialMediaskeleton">
      <Col md={6} lg={6} sm={6}>
        <Skeleton count={1} height={30} width={500} />
      </Col>
      <Col md={6} lg={6} sm={6}>
        <Skeleton count={1} height={30} width={500} />
      </Col>
    </Row>
  );
};
export default ConfigSocialMediaSkeleton;
